<div fxLayout="row" style="padding: 20px 10px 20px 10px;">
    <div class="center-vertical" fxFlex="20%">
        <p>Total: {{this.showedRows.length}} sur {{totalRows}}</p>
    </div>
    <div class="center-vertical" fxFlex="40%" fxLayoutAlign="center center">
        <button type="button" class="button-secondary-small" (click)="studentSetting()"  style="white-space: nowrap; align-items: center; display: flex; margin-right: 3px;">
            <mat-icon fontIcon="settings" style="color: gray; cursor: pointer; margin-right: 5px; font-size: 20px; width: fit-content; height: fit-content;"></mat-icon>
            <div>Student Setting</div>
        </button>
    </div>
    <div class="center-vertical" fxFlex="40%" style="display: flex; align-items: center;">
        <div style="margin-left: auto;">
            <input class="col-input"  (keyup)="applyFilterLocal($event.target, 'all_column')" placeholder="Search">
        </div>
    </div>
</div>
<div class="table_div" style="height: calc(100% - 170px);">
    <div class="nav-preview" fxLayout="row" fxLayoutAlign="center center" style="float: bottom; position: absolute;">
        <mat-icon [ngClass]="navIndex === 0 ? 'nav-inactive' : 'nav-active'"style="padding: 0px 14px 0px 0px; font-size: 40px; height: 40px;" fontIcon="arrow_left" title="Previous" (click)="movePrevNextNavigation('prev')"></mat-icon>
        <span style="font-weight: bold;"> Nav {{ navIndex *  this.filterData.limit}} / {{ totalRows}}</span>
        <mat-icon [ngClass]="navIndex === totalNavigations - 1 ? 'nav-inactive' : 'nav-active'" style="padding-right: 10px; font-size: 40px; height: 40px;" fontIcon="arrow_right" title="Next" (click)="movePrevNextNavigation('next')"></mat-icon>
    </div>
    <table>
        <thead>
        <tr>
            <th><div class="column-name">Id</div></th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_student', 'number')"></mat-icon>
                <div class="column-name">Id Student</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id_student')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'belongs', 'string')"></mat-icon>
                <div class="column-name">Belongs</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'belongs')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'student_institution', 'string')"></mat-icon>
                <div class="column-name">Instidution</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'student_institution')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'student_study', 'string')"></mat-icon>
                <div class="column-name">Study</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'student_study')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'pseudo', 'string')"></mat-icon>
                <div class="column-name">Pseudo</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'pseudo')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'email', 'string')"></mat-icon>
                <div class="column-name">Email</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'email')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'phone', 'string')"></mat-icon>
                <div class="column-name">Phone</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'phone')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'device_system', 'string')"></mat-icon>
                <div class="column-name">Device System</div>
                <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'device_system')">
                    <mat-option [value]="''">ALL</mat-option>
                    <mat-option *ngFor="let element of deviceSystems" [value]="element">{{element}}</mat-option>
                </mat-select>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'subscription_name', 'string')"></mat-icon>
                <div class="column-name">Subscription</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'subscription_name')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_content', 'number')"></mat-icon>
                <div class="column-name">Nb. Content</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_content')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'active_date', 'date')"></mat-icon>
                <div class="column-name">Last Active Date</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'active_date')"></div>
            </th>
            <th>
                <div style="display: flex; justify-content: center;"><input #checkedAllRef type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer; " (change)="selectAll($event.target)"></div>
                
            </th>
        </tr>
        </thead>
        <tbody #row_tbody *ngFor="let row of showedRows; let i = index">
            <tr (click)="toggleRow(row, $event.target, row_tbody)">
                <td>{{row['id_row']}}</td>
                <td>{{row['id_student']}}</td>
                <td matTooltip="{{ row['belongs'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['belongs'] }}</td>
                <td matTooltip="{{ row['student_institution'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['student_institution'] }}</td>
                <td matTooltip="{{ row['student_study'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['student_study'] }}</td>
                <td matTooltip="{{ row['pseudo'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['pseudo'] }}</td>
                <td matTooltip="{{ row['email'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['email'] }}</td>
                <td matTooltip="{{ row['phone'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['phone'] }}</td>
                <td>{{ row['device_system'] }}</td>
                <td matTooltip="{{ row['subscription_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['subscription_name'] }}</td>
                <td>{{row['nb_content_student']}} ~ {{ row['nb_content'] }}</td>
                <td>{{ row['active_date'] }}</td>
                <td><input type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer; " [checked]="row['checked']" (change)="selectRow($event.target, i)"></td>
            </tr>
            <tr class="expand_detail" *ngIf="row['expanded']">
                <td colspan="14">
                    <app-student-detail [rowInfos]="row" [userInfos]="userInfos" [platformInfos]="platformInfos" [promotionAllData]="promotionAllData" (inProgress)="setWaiting($event)"></app-student-detail>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="showedRows.length === 0">
            <tr ><td colspan="14" style="text-align: center;">No matching records found</td></tr>
        </tbody>
    </table>
</div>